import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as instantMessageService from "../../services/instantMessageService";
import { handleApiError } from "../storeEffects";
import { InstantMessageAction, instantMessageFailure, instantMessageSuccess } from "./storeInstantMessage";

export type InstantMessageThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, InstantMessageAction>

export const getInstantMessagePage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return instantMessageService.getInstantMessagePage()
        .then(
            instantMessagePage => {
                dispatch(instantMessageSuccess(instantMessagePage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(instantMessageFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};